import { Button, Container, Grid, makeStyles } from '@material-ui/core';
import { GenericDrawer } from 'app/components/GenericDrawer/GenericDrawer';
import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Search from './Search/Search';
import SearchIcon from '@material-ui/icons/Search';

import styles from './styles';
const useStyles = makeStyles(styles);

const SearchRequest = props => {
  const classes = useStyles();

  const [openDrawer, setOpenDrawer] = useState(false);

  const onCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const onOpenDrawer = row => {
    setOpenDrawer(true);
  };

  return (
    <>
      <GenericDrawer
        open={openDrawer}
        title="Selecione a solicitação"
        onClose={() => onCloseDrawer()}
      >
        <Container>
          <Grid container spacing={3} className={classes.containerSearchField}>
            <Search
              {...props}
              openDrawer={openDrawer}
              onCloseDrawer={onCloseDrawer}
            />
          </Grid>
        </Container>
      </GenericDrawer>
      <Grid container spacing={3} className={classes.containerBtn}>
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            type="button"
            disableElevation
            className={classes.searchRequest}
            endIcon={<SearchIcon />}
            onClick={() => onOpenDrawer()}
          >
            <FormattedMessage id="LABELS.SERVICES.SEARCH_REQUEST" />
          </Button>
        </Grid>
        <Grid item xs={12} className={classes.noRequest}>
          <FormattedMessage id="MESSAGES.SERVICE.FORMS.NO_REQUEST_SELECTED" />
        </Grid>
      </Grid>
    </>
  );
};

export default injectIntl(SearchRequest);
